import isFullArray from "./isFullArray";

export default price => (isFullArray(price) ? price / 100 : "");
